'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('webaccess-list', {
      url: '/webaccess/list',
      template: '<webaccess-list></webaccess-list>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/webaccess/list/webaccess-list.routes.js